import { Avatar } from 'antd'
import { useGetEventDropInList } from 'api/Event/Dropin'
import ApiError from 'components/global/ApiError'
import Spinner from 'components/Spinner'
import { getNameSignature } from 'helper/utility'
import React, { useEffect } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'

interface AttendeesListProps {
  params: any
  setParams: React.Dispatch<React.SetStateAction<any>>
}

const AttendeesList = ({ params, setParams }: any) => {
  const {
    data: dropInAttendeesList,
    isLoading: isDropInAttendeesListLoading,
    isFetching: isDropInAttendeesListFetching,
    refetch: refetchDropInAttendeesList,
    error: dropInAttendeesListError,
  } = useGetEventDropInList(params.eventId, params.date)
  const {
    setDetailedDropInModalOpen,
    setDropInModalOpen,
    setParticipantData,
    participantData,
  } = eventAttendanceStore(store => ({
    setDetailedDropInModalOpen: store.setDetailedDropInModalOpen,
    setDropInModalOpen: store.setDropInModalOpen,
    setParticipantData: store.setParticipantData,
    participantData: store.participantData,
  }))

  const handleAttendeeClick = (attendee: any) => {
    setParticipantData(attendee)
    setDetailedDropInModalOpen(true)
    setDropInModalOpen(false)
  }

  useEffect(() => {
    refetchDropInAttendeesList()
  }, [params])

  if (isDropInAttendeesListLoading || isDropInAttendeesListFetching)
    return (
      <div className="py-40px">
        <Spinner />
      </div>
    )

  if (dropInAttendeesListError)
    return <ApiError reload={refetchDropInAttendeesList} />

  return (
    <div className="mt-20px">
      {dropInAttendeesList.length ? (
        dropInAttendeesList.map(attendee => {
          return (
            <div
              className="flex align-center gap-10px mt-15px pointer"
              key={attendee._id}
              onClick={() => handleAttendeeClick(attendee)}
            >
              <Avatar size={40} src={attendee.photo?.thumb}>
                {getNameSignature(attendee.firstName + attendee.lastName)}
              </Avatar>
              <h4 className="text-14 w-500">{`${attendee.firstName} ${attendee.lastName}`}</h4>
            </div>
          )
        })
      ) : (
        <div>
          <h3>No attendees found</h3>
        </div>
      )}
    </div>
  )
}

export default AttendeesList
